import Scrollbar from '@aibees/shared/components/scrollbar/scrollbar';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CompanySummary } from '../company-summary';
import { JobSummary } from '../job-summary';
import * as Styled from './styles';
import * as SX from './sx';
import type { JobHistoryProps as Props } from './types';

export const JobHistory = memo(
  ({
    className,
    isCompanySummary,
    currentRoles,
    groupedCurrentRoles,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('JobHistory', className)}
        sx={SX.root}
      >
        <Scrollbar sx={SX.scrollBar}>
          {isCompanySummary ? (
            <CompanySummary currentRoles={groupedCurrentRoles} />
          ) : (
            <JobSummary currentRoles={currentRoles} />
          )}
        </Scrollbar>
      </Styled.Wrapper>
    );
  }
);

JobHistory.displayName = 'JobHistory';
